//
//
//
//
//
//
//
//

import encode from "../../server/api/encode";

export default {
  methods: {
    goPage(event) {
      let jumpUrl = event.target.innerText.match(/\d+/g)[0];
      var encodeUrlStr = encodeURIComponent(
        JSON.stringify({
          linkUrl: "https://pubmed.ncbi.nlm.nih.gov/" + jumpUrl,
          navigationTitle: "参考文献",
        })
      );
      var linkUrl =
        "https://tool.yxj.org.cn/app/" +
        encode.encodeFunc("h5_web?rk=" + encodeUrlStr).data;
      console.log(linkUrl, "-----------------");
      goPage({ url: linkUrl });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/formulaComponent/pubmed.vue